export function authCallbackState(search: string, hash: string): 'none' | 'pending' | 'error' {
  const query = new URLSearchParams(search);
  const fragment = new URLSearchParams(hash.replace(/^#/, ''));
  const has = (key: string) => query.has(key) || fragment.has(key);
  if (has('error') || has('error_description')) return 'error';
  const type = query.get('type') ?? fragment.get('type');
  return ['code', 'access_token', 'refresh_token', 'token_hash'].some(has)
    || (type !== null && ['recovery', 'magiclink', 'invite'].includes(type))
    ? 'pending'
    : 'none';
}
